function hooks() {
  const shouldApplyDefaultInStock =
    !window.__fsDefaultInStockApplied;

  window.__fsDefaultInStockApplied = true;

  const url = new URL(window.location.href);

  const isSearchOrCollection =
    url.pathname.includes("/search") ||
    url.pathname.includes("/collections");

  if (isSearchOrCollection) {
    const filters = url.searchParams.get("filters");

    if (
      shouldApplyDefaultInStock &&
      (!filters || !filters.includes("In Stock,True"))
    ) {
      if (filters) {
        url.searchParams.set(
          "filters",
          filters + ",In Stock,True"
        );
      } else {
        url.searchParams.set(
          "filters",
          "In Stock,True"
        );
      }

      window.location.replace(url.toString());
      return;
    }
  }

// The filter already exists, so continue running the rest of hooks()



  window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.refresh(true).then(() => {
      cartDrawer.open();
    });
  });

  window.SerpOptions.registerHook('serp-product-grid', ({products, element}) => {
    console.log('Fast Simon Hooks Initialized');
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q');
    if (searchQuery && document.querySelector('.search__title')) {
      document.querySelector('.search__title').textContent = `Search results for: '${searchQuery}'`;
    }

    element.querySelectorAll('.fs-results-product-card').forEach((productCard) => {
      let showProductStatus = 'false' === 'true';
      let showProductShipping = 'false' === 'true';

      if (productCard.querySelector('.product-card-items-wrapper').classList.contains('fs-card-init')) return;
      productCard.querySelector('.product-card-items-wrapper').classList.add('fs-card-init');
      if (productCard.querySelector('.fs-product-status') || productCard.querySelector('.fs-product-shipping')) return;

      let productId = productCard.dataset.productId;
      let productData = products[productId];

      console.log(productData);

      // Parse metafield map once for O(1) retrieval
      const attrMap = Object.fromEntries(productData.attributes || []);

      // Check for preorder metafield and remove "Out of Stock" badge if true
      const isPreorder = attrMap["custom.preorder"]?.[0] === 'true';
      if (isPreorder) {
        const outOfStockWrapper = productCard.querySelector('.out-of-stock-wrapper');
        if (outOfStockWrapper) {
          outOfStockWrapper.remove();
        }
      }

      if (productData && !productData.isSoldOut && showProductStatus) {
        let statusDiv = document.createElement('div');
        statusDiv.className = 'fs-product-status';
        statusDiv.textContent = 'In Stock';
        productCard.querySelector('.fs-serp-product-title').insertAdjacentElement('afterend', statusDiv);
      }

      if (productData && productData.isSoldOut && showProductStatus) {
        let statusDiv = document.createElement('div');
        statusDiv.className = 'fs-product-status';
        statusDiv.textContent = 'Out of Stock';
        productCard.querySelector('.fs-serp-product-title').insertAdjacentElement('afterend', statusDiv);
      }

      if (productData && productData.isSoldOut) {
        let buttonHolder = productCard.querySelector('.add-to-cart-button-wrapper');
        buttonHolder.innerHTML = `
          <a href="${productData.productURL}" class="fs-sold-out-button">
            Notify Me
          </a>
        `;
      }

      if (showProductShipping) {
        let shippingDiv = document.createElement('div');
        shippingDiv.className = 'fs-product-shipping';
        shippingDiv.textContent = 'Free standard shipping included';
        productCard.querySelector('.fs-serp-info').append(shippingDiv);
      }

      let cartButton = productCard.querySelector('.add-to-cart-button-wrapper');
      let infoContainer = productCard.querySelector('.fs-serp-info');
      if (cartButton) {
        cartButton.remove();
        infoContainer.append(cartButton);
      }

      let reviewCount = productCard.querySelector('.fs-reviews-count');
      if (reviewCount && reviewCount.innerText.trim() === '(0)') {
        reviewCount.closest('.fs-serp-reviews').remove();
      }

const priceContainer = productCard.querySelector('.price-container');
const compareContainer = productCard.querySelector('.compare-container');
let priceWrapper = productCard.querySelector('.card-price-container');

if (priceContainer && infoContainer && cartButton) {
  if (!priceWrapper) {
    priceWrapper = document.createElement('div');
    priceWrapper.className = 'card-price-container';
  }

  // Put the regular and crossed-out prices together
  priceWrapper.append(priceContainer);

  if (compareContainer) {
    priceWrapper.append(compareContainer);
  }

  // Put the entire price row immediately above Add to Cart
  infoContainer.insertBefore(priceWrapper, cartButton);
}

      if (productData && !productData.isSoldOut && productData.variants.length > 1) {
        let cardButton = productCard.querySelector('.add-to-cart-button.fs-add-to-cart-button.ajax_add_to_cart .add-to-cart-spinner-text-wrapper span');
        if (cardButton) {
          cardButton.innerText = 'Choose Options';
        }
      }
      
      // Buy With Prime - replace Add to Cart with "View Product" button
      if (
        productData &&
        !productData.isSoldOut &&
        Array.isArray(productData.tags) &&
        productData.tags.some(tag => tag.trim() === 'Buy With Prime')
      ) {
        const buttonHolder = productCard.querySelector('.add-to-cart-button-wrapper');
        const originalButton = productCard.querySelector('.fs-add-to-cart-button');

        if (buttonHolder && originalButton && !buttonHolder.classList.contains('fc-bwp-applied')) {
          buttonHolder.classList.add('fc-bwp-applied');

          // Get exact styling from original button
          const styles = window.getComputedStyle(originalButton);
          
          buttonHolder.innerHTML = `
            <a href="${productData.productURL}"
              style="
                display:${styles.display};
                align-items:${styles.alignItems};
                justify-content:${styles.justifyContent};
                width:100%;
                min-height:${styles.minHeight};
                padding:${styles.padding};
                margin:${styles.margin};
                border-radius:${styles.borderRadius};
                font-size:${styles.fontSize};
                font-weight:${styles.fontWeight};
                line-height:${styles.lineHeight};
                text-align:center;
                text-decoration:none;
                background-color:#158cfc;
                color:#ffffff;
                box-sizing:${styles.boxSizing};
              ">
              View Product
            </a>
          `;
        }
      }
      if ( // Coming Soon - replace Add to Cart with "Coming Soon" button
        productData &&
        !productData.isSoldOut &&
        Array.isArray(productData.tags) &&
        productData.tags.some(tag => tag.trim() === 'coming-soon')
      ) {
        const buttonHolder = productCard.querySelector('.add-to-cart-button-wrapper');
        const originalButton = productCard.querySelector('.fs-add-to-cart-button');

        if (buttonHolder && originalButton && !buttonHolder.classList.contains('fc-coming-soon-applied')) {
          buttonHolder.classList.add('fc-coming-soon-applied');

          const styles = window.getComputedStyle(originalButton);
          
          buttonHolder.innerHTML = `
            <a href="${productData.productURL}"
              style="
                display:${styles.display};
                align-items:${styles.alignItems};
                justify-content:${styles.justifyContent};
                width:100%;
                min-height:${styles.minHeight};
                padding:${styles.padding};
                margin:${styles.margin};
                border-radius:${styles.borderRadius};
                font-size:${styles.fontSize};
                font-weight:${styles.fontWeight};
                line-height:${styles.lineHeight};
                text-align:center;
                text-decoration:none;
                background-color:#6D28D9;
                color:#ffffff;
                box-sizing:${styles.boxSizing};
              ">
              Pre-Order Soon
            </a>
          `;
        }
      }
      // Preorder - replace Add to Cart with "Pre-order" button
      else if (
        productData &&
        !productData.isSoldOut &&
        attrMap["custom.preorder"]?.[0] === 'true'
      ) {
        const buttonHolder = productCard.querySelector('.add-to-cart-button-wrapper');
        const originalButton = productCard.querySelector('.fs-add-to-cart-button');

        if (buttonHolder && originalButton && !buttonHolder.classList.contains('fc-preorder-applied')) {
          buttonHolder.classList.add('fc-preorder-applied');

          const styles = window.getComputedStyle(originalButton);
          
          buttonHolder.innerHTML = `
            <a href="${productData.productURL}"
              style="
                display:${styles.display};
                align-items:${styles.alignItems};
                justify-content:${styles.justifyContent};
                width:100%;
                min-height:${styles.minHeight};
                padding:${styles.padding};
                margin:${styles.margin};
                border-radius:${styles.borderRadius};
                font-size:${styles.fontSize};
                font-weight:${styles.fontWeight};
                line-height:${styles.lineHeight};
                text-align:center;
                text-decoration:none;
                background-color:#D4242F;
                color:#ffffff;
                box-sizing:${styles.boxSizing};
              ">
              Pre-order Now
            </a>
          `;
        }
      }
    });
  });
}

// execution here
if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener('fast-serp-ready', function () {
    hooks();
  });
}